var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8335 10.375H7.66684C7.32517 10.375 7.04184 10.0916 7.04184 9.74997C7.04184 9.4083 7.32517 9.12497 7.66684 9.12497H11.8335C12.1752 9.12497 12.4585 9.4083 12.4585 9.74997C12.4585 10.0916 12.1752 10.375 11.8335 10.375Z",
    fill: "#919191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75015 12.4584C9.40849 12.4584 9.12515 12.175 9.12515 11.8334V7.66666C9.12515 7.32499 9.40849 7.04166 9.75015 7.04166C10.0918 7.04166 10.3752 7.32499 10.3752 7.66666V11.8334C10.3752 12.175 10.0918 12.4584 9.75015 12.4584Z",
    fill: "#919191"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58332 18.125C4.87499 18.125 1.04166 14.2917 1.04166 9.58335C1.04166 4.87502 4.87499 1.04169 9.58332 1.04169C14.2917 1.04169 18.125 4.87502 18.125 9.58335C18.125 14.2917 14.2917 18.125 9.58332 18.125ZM9.58332 2.29169C5.55832 2.29169 2.29166 5.56669 2.29166 9.58335C2.29166 13.6 5.55832 16.875 9.58332 16.875C13.6083 16.875 16.875 13.6 16.875 9.58335C16.875 5.56669 13.6083 2.29169 9.58332 2.29169Z",
    fill: "#919191"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 18.9583C18.1753 18.9583 18.017 18.9 17.892 18.775L16.2253 17.1083C15.9837 16.8666 15.9837 16.4666 16.2253 16.225C16.467 15.9833 16.867 15.9833 17.1087 16.225L18.7753 17.8916C19.017 18.1333 19.017 18.5333 18.7753 18.775C18.6503 18.9 18.492 18.9583 18.3337 18.9583Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchZoomIn);
export default __webpack_public_path__ + "static/media/search-zoom-in.eed32831147303e6769aa5bbe0feb8cf.svg";
export { ForwardRef as ReactComponent };